export default defineNuxtRouteMiddleware((to) => {
  if (to.path.includes('.aspx')) {
    return navigateTo(to.fullPath.replace('.aspx', ''));
  } else if (to.path.includes('.ASPX')) {
    return navigateTo(to.fullPath.replace('.ASPX', ''));
  }
});
